import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-06005cc8"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row justify-content-center mb-3" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "col-6 regist-h" }, "会員登録完了")
], -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row justify-content-center mt-3" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-12 text-small" }, " 会員登録が完了しました。 ")
], -1))
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-12 text-center" }

import { onMounted } from 'vue'
import { useRouter } from 'vue-router';


export default /*#__PURE__*/_defineComponent({
  emits: ['stopLoading'],
  setup(__props, { emit }) {



const router = useRouter();

onMounted(async() => {
  emit('stopLoading');
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("button", {
          class: "btn btn-primary",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).push('/')))
        }, "マイページへ")
      ])
    ])
  ], 64))
}
}

})